import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import ActivityOverviewCard from './ActivityOverviewCard';
import AlertsOverviewCard from './AlertsOverviewCard';
import AppointmentsOverviewCard from './AppointmentsOverviewCard';
import LatestMeasurementsCard from './LatestMeasurementsCard';
import MedicationOverviewCard from './MedicationOverviewCard';
import NotesOverviewCard from './NotesOverviewCard';
import QuestionnairesOverviewCard from './QuestionnairesOverviewCard';
import RehabilitationEvolutionCard from './RehabilitationEvolutionCard';
import StressTestsOverviewCard from './StressTestsOverviewCard';
import ThirtyDaySummaryCard from './ThirtyDaySummaryCard';

const PatientOverview = ({
    patientUuid,
    patientCreated,
    plans,
    plansLoading,
    plansError,
    onNavigate,
    onScheduleAppointment,
    onAddStressTest,
    onAddMeasurement
}) => {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
                gap: 1.5,
                minWidth: 1040
            }}
        >
            <Box sx={{ gridColumn: 'span 9' }}>
                <RehabilitationEvolutionCard
                    patientUuid={patientUuid}
                    patientCreated={patientCreated}
                    plans={plans}
                    plansLoading={plansLoading}
                    plansError={plansError}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 3' }}>
                <ThirtyDaySummaryCard patientUuid={patientUuid} />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <ActivityOverviewCard
                    patientUuid={patientUuid}
                    plans={plans}
                    plansLoading={plansLoading}
                    plansError={plansError}
                    onViewActivity={() => onNavigate('atividade')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <LatestMeasurementsCard
                    key={patientUuid}
                    patientUuid={patientUuid}
                    onAddMeasurement={onAddMeasurement}
                    onViewMeasurements={() => onNavigate('medicoes')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <StressTestsOverviewCard
                    patientUuid={patientUuid}
                    onAddStressTest={onAddStressTest}
                    onViewExams={() => onNavigate('exames')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <MedicationOverviewCard
                    patientUuid={patientUuid}
                    onViewMedication={() => onNavigate('medicacao')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <AlertsOverviewCard
                    patientUuid={patientUuid}
                    onViewAlerts={() => onNavigate('alertas')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <NotesOverviewCard key={patientUuid} patientUuid={patientUuid} />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <AppointmentsOverviewCard
                    patientUuid={patientUuid}
                    onSchedule={onScheduleAppointment}
                    onViewAppointments={() => onNavigate('consultas')}
                />
            </Box>

            <Box sx={{ gridColumn: 'span 6' }}>
                <QuestionnairesOverviewCard
                    patientUuid={patientUuid}
                    onViewQuestionnaires={() => onNavigate('questionarios')}
                />
            </Box>
        </Box>
    );
};

PatientOverview.propTypes = {
    patientUuid: PropTypes.string.isRequired,
    patientCreated: PropTypes.string,
    plans: PropTypes.arrayOf(PropTypes.object).isRequired,
    plansLoading: PropTypes.bool.isRequired,
    plansError: PropTypes.bool.isRequired,
    onNavigate: PropTypes.func.isRequired,
    onScheduleAppointment: PropTypes.func.isRequired,
    onAddStressTest: PropTypes.func.isRequired,
    onAddMeasurement: PropTypes.func
};

export default PatientOverview;
